import { render, staticRenderFns } from "./StudentGroupStatistics.vue?vue&type=template&id=2394364c&scoped=true"
import script from "./StudentGroupStatistics.vue?vue&type=script&lang=js"
export * from "./StudentGroupStatistics.vue?vue&type=script&lang=js"
import style0 from "./StudentGroupStatistics.vue?vue&type=style&index=0&id=2394364c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394364c",
  null
  
)

export default component.exports